import { ModalOptionsConfig } from './modal.service';

import { Component, TemplateRef, ViewContainerRef } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';


@Component({
	selector: 'app-nz-modal-service',
	templateUrl: './nz-modal-service.component.html',
	styleUrls: ['./nz-modal-service.component.scss']
})

export class NzModalServiceComponent {
	tplModalButtonLoading = false;
	disabled = false;

	constructor(private modal: NzModalService, private viewContainerRef: ViewContainerRef) { }

	createModal(): void {
		this.modal.create({
			nzTitle: 'Modal Title',
			nzContent: 'string, will close after 1 sec',
			nzClosable: false,
			nzOnOk: () => new Promise(resolve => setTimeout(resolve, 1000))
		});
	}

	createTplModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>): void {
		this.modal.create({
			nzTitle: tplTitle,
			nzContent: tplContent,
			nzFooter: tplFooter,
			nzMaskClosable: false,
			nzClosable: false,
			nzData: {
				value: 'Template Context'
			}
		});
	}

	destroyTplModal(modelRef: NzModalRef): void {
		this.tplModalButtonLoading = true;
		setTimeout(() => {
			this.tplModalButtonLoading = false;
			modelRef.destroy();
		}, 1000);
	}

	createComponentModal(customComponent, options?: ModalOptionsConfig) {
		const modal = this.modal.create({
			...(!options.hideNZTitle && { nzTitle: `<img src='/assets/images/moniepoint-logo.svg'>` }),
			nzContent: customComponent,
			nzViewContainerRef: this.viewContainerRef,
			nzData: options.nzComponentParams || {},
			nzFooter: null,
			nzClosable: options.nzClosable || false,
			nzMaskClosable: options.nzMaskClosable || false,
			nzBodyStyle: options.style || {},
			nzClassName: options.className || '',
			nzWidth: options.nzWidth || 496,
			nzCentered: options.nzCentered,
			nzAutofocus: options.nzAutofocus,
			nzKeyboard: options.nzKeyboard ? true : false,
			...options.nzComponentParams
		});
		return modal;
	}

	createCustomButtonModal(): void {
		const modal: NzModalRef = this.modal.create({
			nzTitle: 'custom button demo',
			nzContent: 'pass array of button config to nzFooter to create multiple buttons',
			nzFooter: [
				{
					label: 'Close',
					shape: 'round',
					onClick: () => modal.destroy()
				},
				{
					label: 'Confirm',
					type: 'primary',
					onClick: () => this.modal.confirm({ nzTitle: 'Confirm Modal Title', nzContent: 'Confirm Modal Content' })
				},
				{
					label: 'Change Button Status',
					type: 'primary',
					danger: true,
					loading: false,
					onClick(): void {
						this.loading = true;
						setTimeout(() => (this.loading = false), 1000);
						setTimeout(() => {
							this.loading = false;
							this.disabled = true;
							this.label = 'can not be clicked！';
						}, 2000);
					}
				},
				{
					label: 'async load',
					type: 'dashed',
					onClick: () => new Promise(resolve => setTimeout(resolve, 2000))
				}
			]
		});
	}

	openAndCloseAll(): void {
		let pos = 0;

		['create', 'info', 'success', 'error'].forEach(method =>
			// @ts-ignore
			this.modal[method]({
				nzMask: true,
				nzTitle: `Test ${method} title`,
				nzContent: `Test content: <b>${method}</b>`,
				nzStyle: { position: 'absolute', top: `${pos * 70}px`, left: `${pos++ * 300}px` }
			})
		);

		setTimeout(() => this.modal.closeAll(), 2000);
	}
}

// @Component({
// 	selector: 'nz-modal-custom-component',
// 	template: `
//     <div>
//       <h2>{{ title }}</h2>
//       <h4>{{ subtitle }}</h4>
//       <p>
//         <span>Get Modal instance in component</span>
//         <button nz-button [nzType]="'primary'" (click)="destroyModal()">destroy modal in the component</button>
//       </p>
//     </div>
//   `
// })
// export class NzModalCustomComponent {
// 	@Input() title?: string;
// 	@Input() subtitle?: string;

// 	constructor(private modal: NzModalRef) { }

// 	destroyModal(): void {
// 		this.modal.destroy({ data: 'this the result data' });
// 	}
// }
